import React from 'react'
import HeadShake from 'react-reveal/HeadShake'

export default ({ children, shake }) => (
  shake ? <HeadShake>{children}</HeadShake> : <>{children}</>
);